import { Form, Formik } from "formik";
import InputField from "../../../../atoms/InputField";
import Button from "../../../../atoms/Button";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { REGISTER_SUGGESTION } from "../../../../../api/apiQuejas";

const ModalSuggestionForm = ({ empresa, onClose }) => {
    const initialValues = {
        body: "",
        clientId: empresa?.id,
        accountantId: empresa?.accountantId || null,
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await REGISTER_SUGGESTION(values);
            toast.success("Registro exitoso");
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setSubmitting(false);
        }
    };

    return(
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
        >
            {({ isSubmitting }) => (
                <Form>
                    <InputField name="body" label="Queja o sugerencia" type="textarea" />
                    <Button text={isSubmitting ? <PropagateLoader color="red" /> : "Registrar"} type="submit" disabled={isSubmitting} bgColor="blue" />
                </Form>
            )}
        </Formik>
    );
};

export default ModalSuggestionForm;